<template>
  <div class="hzc-login">
    <img src="../../assets/images/waiconfirm.png" @click="confirmLogin" class="wai-confirm" alt="">
    <p>登录</p>
    <label>
      <el-input type="text" maxlength="14" v-model="loginForm.username" clearable></el-input>
    </label>
<!--    <img src="../assets/images/confirm.png" class="confirm" @click="emptyInput" alt="">-->
    <label>
      <el-input style="margin-bottom: 4px;margin-top: 20px;" type="password" clearable maxlength="20" v-model="loginForm.password"></el-input>
    </label>
    <div class="login-tips" v-if="tipsHidden">用户名或密码错误！</div>
    <el-button class="login-btn" @click.native.prevent="handleLogin">登录</el-button>
    <div class="passDiv">
      <el-checkbox v-model="loginForm.rememberMe"></el-checkbox>
      记住密码
      <span @click="goChangePassword">忘记密码?</span>
    </div>
  </div>
</template>

<script>
import store from '../../store'
import Cookies from "js-cookie";
import {encryptByDES} from '@/utils/jsencrypt'

export default {
  name: "login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        rememberMe: true,
      },
      loading: false,
      tipsHidden: false,
    }
  },
  created() {
    let that = this;
    document.onkeypress = function (e) {
      const keycode = document.all ? event.keyCode : e.which;
      if (keycode === 13) {
        that.handleLogin();   // 回车搜索事件
        return false;
      }
    };
    this.getCookie();
  },
  methods: {
    confirmLogin() {
      this.$emit('confirmLogin', false)
    },
    /**
     * 清空输入框
     */
    emptyInput() {
      this.loginForm['username'] = '';
      this.loginForm['password'] = '';
    },
    /**
     * 获取本地cookie
     */
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    /**
     * 判断是否输入账号密码
     */
    valid() {
      if (this.loginForm['username'] !== '' && this.loginForm['password'] !== '') {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 前往修改密码
     */
    goChangePassword() {
      window.openUrl('https://www.risuncloud.com/find-pwd');
    },
    /**
     * 登陆
     */
    handleLogin() {
      if (this.valid) {
        this.loading = true;
        this.tipsHidden = false;
        const data = JSON.parse(JSON.stringify(this.loginForm))
        data['password'] = encryptByDES(data.password)
        if (this.loginForm.rememberMe) {
          Cookies.set("username", this.loginForm.username, {expires: 30});
          Cookies.set("password", this.loginForm.password, {expires: 30});
          Cookies.set('rememberMe', this.loginForm.rememberMe, {expires: 30});
        } else {
          Cookies.remove("username");
          Cookies.remove("password");
          Cookies.remove('rememberMe');
        }
        this.$store.dispatch("Login", data).then(() => {
          store.dispatch('GetInfo').then(() => {
          }).catch(err => {
            console.log(err)
          })
          this.$emit('loginTrue', false)
        }).catch(() => {
          this.loading = false;
          this.tipsHidden = true;
        });
      }
    }
  }
}
</script>

<style scoped lang="less">
.hzc-login {
  width: 280px;
  height: 280px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 32px;
  position: relative;

  .wai-confirm {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }

  .confirm {
    position: absolute;
    top: 108px;
    right: 37px;
    cursor: pointer;
  }

  p {
    width: 48px;
    height: 33px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
    line-height: 33px;
    margin-bottom: 32px;
  }

  input {
    width: 260px;
    height: 36px;
    background: #F8F8F8;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    margin-bottom: 24px;
    outline: none;
    padding: 0 10px;
  }

  .login-tips {
    color: #AC1307;
  }

  .login-btn {
    width: 280px;
    height: 40px;
    background: #D3131A;
    border-radius: 4px;
    margin-top: 16px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    border: none;
  }

  .passDiv {
    margin-top: 8px;

    .el-checkbox {
      margin-right: 4px;
    }

    span {
      float: right;
      color: #D3131A;
      cursor: pointer;
    }
  }
}
</style>
